import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AddressComponent } from 'src/app/components/dialogs/client-address/address/address.component';
import { DeleteaddressComponent } from 'src/app/components/dialogs/client-address/deleteaddress/deleteaddress.component';
import { MediaObserver } from '@angular/flex-layout';
import { ClientaddressesService } from 'src/app/services/apiclient/clientaddresses/clientaddresses.service';

@Component({
  selector: 'app-addresses-backoffice-client',
  templateUrl: './addresses-backoffice-client.component.html',
  styleUrls: ['./addresses-backoffice-client.component.css']
})
export class AddressesBackofficeClientComponent implements OnInit {

  @Input()
  clientAddresses$: any;

  @Input()
  type:any;

  // RESPONSIVE
  respCols:any = {
    "xs": 1,
    "sm": 2,
    "md": 2,
    "lg": 2,
    "xl": 3
  };

  currCols: number = (this.media.isActive("xs")) ? 1 : 2;
  rowHeight: number = (this.media.isActive("xs")) || (this.media.isActive("sm")) || (this.media.isActive("md")) ? 150 : 200;

  delivryAddress$: any;
  billingAddress$: any;

  loader: boolean = true;

  constructor(
    private media: MediaObserver,
    private dialog: MatDialog,
    private addressApi: ClientaddressesService
  ) {
    this.media.asObservable().subscribe((media:any) => {
      this.currCols = this.respCols[media.mqAlias];
    });
  }

  ngOnInit() {
    this.getAddress();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["clientAddresses$"].currentValue) {
      this.loader = false;
    }
  }

  getAddress(): void {

    if (this.type === "delivry") {

      this.addressApi.getDelivryAddress.subscribe(address => {
        this.delivryAddress$ = address;
      });

    } else if (this.type === "billing") {

      this.addressApi.getBillingAddress.subscribe(address => {
        this.billingAddress$ = address;
      });

    }

  }

  selectAddress(address: any): void {

    if (this.type === "billing") {

      this.addressApi.setBillingAddress(address);

    } else if (this.type === "delivry") {

      this.addressApi.setDelivryAddress(address);

    }

  }

  // DIALS

  openDialAddress(address?: any): void {

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      address: address,
      addressesLgth: this.clientAddresses$.length,
      type: this.type
    };

    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "700px";

    const myDial = this.dialog.open(AddressComponent, myConf);

    myDial.afterClosed().subscribe(data => {
      if (data) {
        this.setAddresses(data);
      }
    });

  }

  openDialDeletAddress(addressId: any) {

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      addressId: addressId,
      from: this.type
    };

    const myDial = this.dialog.open(DeleteaddressComponent, myConf);

    myDial.afterClosed().subscribe(data => {

      if (data) {
        this.setAddresses(data);
      }

    });
  }

  setAddresses(addresses: boolean) {
    this.addressApi.setAddresses(addresses);
  }


}
